import PropTypes from 'prop-types';
import React from 'react';
import { Common } from 'ws-scripts/modules/common';
import { replacePlaceholders } from '../utils/utility';
import {
	FINANCE_DRIVER_PAYMENT_INFO_VDP_TOOLTIP_VERBIAGE,
	THE_DEALERSHIP
} from '../constants/labels';

const DisclaimerContent = ({
	dealershipName,
	disclaimerLabel,
	placeholderValuesObj
}) => {
	return (
		<Common
			render={({ labels }) => {
				const introParagraph = labels.get(
					FINANCE_DRIVER_PAYMENT_INFO_VDP_TOOLTIP_VERBIAGE
				);
				const dealershipText =
					dealershipName === THE_DEALERSHIP
						? labels.get(THE_DEALERSHIP)
						: dealershipName;

				const disclaimerHtml = replacePlaceholders(
					labels.get(disclaimerLabel),
					{
						...placeholderValuesObj,
						'<%=dealershipName%>': dealershipText
					}
				);
				/* eslint react/no-danger: 0 */
				return [
					<div
						key="introHtml"
						dangerouslySetInnerHTML={{ __html: introParagraph }}
					/>,
					<div
						key="disclaimerHtml"
						dangerouslySetInnerHTML={{ __html: disclaimerHtml }}
					/>
				];
			}}
		/>
	);
};

DisclaimerContent.propTypes = {
	dealershipName: PropTypes.string.isRequired,
	disclaimerLabel: PropTypes.string.isRequired,
	placeholderValuesObj: PropTypes.shape().isRequired
};

export default DisclaimerContent;



// WEBPACK FOOTER //
// ./src/components/DisclaimerContent.jsx